/**
 * @flow
 * @relayHash 06ae2822627a97b4d4d286464a256749
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryTemplateUpdateInput = {|
  id: string,
  name: string,
  code: string,
|};
export type UpdateCategoryTemplateMutationVariables = {|
  data: CategoryTemplateUpdateInput
|};
export type UpdateCategoryTemplateMutationResponse = {|
  +updateCategoryTemplate: {|
    +id: string
  |}
|};
export type UpdateCategoryTemplateMutation = {|
  variables: UpdateCategoryTemplateMutationVariables,
  response: UpdateCategoryTemplateMutationResponse,
|};
*/


/*
mutation UpdateCategoryTemplateMutation(
  $data: CategoryTemplateUpdateInput!
) {
  updateCategoryTemplate(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CategoryTemplateUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCategoryTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CategoryTemplateModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCategoryTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCategoryTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCategoryTemplateMutation",
    "id": null,
    "text": "mutation UpdateCategoryTemplateMutation(\n  $data: CategoryTemplateUpdateInput!\n) {\n  updateCategoryTemplate(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ee3e9620e83886977bf30b62d958529c';
module.exports = node;
